export default "__VITE_ASSET__MYm8HXQI__"